import { Button, Container, Row, Col, Form,  Stack } from "react-bootstrap";
import { DataHandler } from "../dataHandler";


function Login() {

    const loginUrl = DataHandler.getServer() + "/j_security_check";

    return (
        <Container fluid="sm" >
            <Row>
                <Col className="text-center">
                    <img width={300} src="hydroLogoKlein.png" alt="hydro logo" />
                </Col>
            </Row>
            <Row>
                <Col className="align-items-center" >
                    <Form action={loginUrl} method="POST">
                        <Stack gap={2}>
                            <Form.Group>
                                <Form.Label>Benutzername</Form.Label>
                                <Form.Control type='text' placeholder="Benutzername" name='j_username' />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Passwort</Form.Label>
                                <Form.Control type='password' name="j_password" />
                            </Form.Group>
                            <Button variant="primary" type='submit' >Anmelden</Button>
                        </Stack>
                    </Form>
                </Col>
            </Row>
        </Container>



    )
}

export default Login;